import React from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MViewItemCopyForm from './MViewItemCopyForm';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';

const mapState = (state, ownProps) => {
  let auth = state.auth;
  let scope = auth?.isAuth ? auth.authorities : {};
  let loading = state.async.loading;

  return {
    scope,
    loading,
  };
};

const actions = {
  closeModal,
};

function ModalViewItemCopy({
  scope,
  loading,
  closeModal,
  data,
}) {
  const id = data?.id;
  const auth = data?.auth;
  const history = useHistory();
  const screenWidth = useScreenWidth();
  const item = data?.item;

  const onFormSubmit = async (values) => {};

  return (
    <Modal
      variant='info'
      label='Detail Soal'
      closeModal={closeModal}
      width={screenWidth > 1000 ? 1000 : screenWidth}
    >
      <MViewItemCopyForm
        id={id}
        auth={auth}
        scope={scope}
        loading={loading}
        history={history}
        closeModal={closeModal}
        initialValues={item}
        onFormSubmit={onFormSubmit}
      />
    </Modal>
  );
}

export default withRouter(connect(mapState, actions)(ModalViewItemCopy));
